module.exports = __webpack_public_path__ + "static/benefit-2-2f25d756749ba9204180af150b596c3f.svg";